import { IFormValues } from '../../task/collectFeedback/Setup';
import { ITaskThreadItem } from '../../task/query';
import { IExtendedFormValues } from './reducer';


interface EditTaskAnswer {
    type: 'EDIT_TASK_ANSWER';
    item: ITaskThreadItem;
}

export function editTaskAnswer(item: ITaskThreadItem): EditTaskAnswer {
    return {
        type: 'EDIT_TASK_ANSWER',
        item
    }
}


interface CancelTaskEditAnswer {
    type: 'CANCEL_TASK_EDIT_ANSWER';
}

export function cancelTaskEditAnswer(): CancelTaskEditAnswer {
    return {
        type: 'CANCEL_TASK_EDIT_ANSWER',
    }
}

interface SaveCollectFeedbackForm {
    type: 'SAVE_COLLECT_FEEDBACK_FORM';
    data: IExtendedFormValues;
}

export function saveCollectFeedbackForm(values: IFormValues, id: string): SaveCollectFeedbackForm {
    return {
        type: 'SAVE_COLLECT_FEEDBACK_FORM',
        data: {
            ...values,
            id,
        }
    }
}

interface ClearCollectFeedbackForm {
    type: 'CLEAR_COLLECT_FEEDBACK_FORM';
}

export function clearCollectFeedbackForm(): ClearCollectFeedbackForm {
    return {
        type: 'CLEAR_COLLECT_FEEDBACK_FORM',
    }
}


export type TaskAction =
    | EditTaskAnswer
    | CancelTaskEditAnswer
    | SaveCollectFeedbackForm
    | ClearCollectFeedbackForm;